import { Link, useNavigate } from 'react-router-dom';
import { Mail, Shield, Globe, Code, Share2, Lock, EyeOff, CheckCircle } from 'lucide-react';
import { useDiagnosticContext } from '../context/DiagnosticContext';
import styles from './Footer.module.css';

export const Footer = () => {
  const navigate = useNavigate();
  const { resetDiagnostic } = useDiagnosticContext();

  const handleStart = (e: React.MouseEvent) => {
    e.preventDefault();
    resetDiagnostic();
    navigate('/diagnostic');
  };

  return (
    <footer className={styles.footer}>
      <div className="wrap">
        <div className={styles.trustBanner}>
          <div className={styles.trustItem}>
            <Lock size={18} />
            <span>No passwords collected</span>
          </div>
          <div className={styles.trustItem}>
            <EyeOff size={18} />
            <span>No personal files collected</span>
          </div>
          <div className={styles.trustItem}>
            <Shield size={18} />
            <span>Secure encrypted uploads</span>
          </div>
          <div className={styles.trustItem}>
            <CheckCircle size={18} />
            <span>AI-generated recommendations</span>
          </div>
        </div>

        <div className={styles.grid}>
          <div className={styles.brand}>
            <div className={styles.logo}>PCCheckr<span>.com</span></div>
            <p className={styles.tagline}>AI-Powered Windows Diagnostics explained in plain English.</p>
            <div className={styles.social}>
              <a href="/" onClick={(e) => e.preventDefault()} aria-label="Twitter"><Globe size={20} /></a>
              <a href="/" onClick={(e) => e.preventDefault()} aria-label="GitHub"><Code size={20} /></a>
              <a href="/" onClick={(e) => e.preventDefault()} aria-label="LinkedIn"><Share2 size={20} /></a>
            </div>
          </div>
          <div className={styles.links}>
            <h4>Product</h4>
            <Link to="/#free-checks">Free Checks</Link>
            <Link to="/#how-it-works">How It Works</Link>
            <Link to="/guide">User Guide</Link>
            <Link to="/pricing">Pricing</Link>
            <button 
              onClick={handleStart} 
              style={{ background: 'none', border: 'none', color: 'inherit', font: 'inherit', cursor: 'pointer', padding: 0, textAlign: 'left' }}
            >
              Get Report
            </button>
          </div>


          <div className={styles.links}>
            <h4>Legal</h4>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/refund-policy">Refund Policy</Link>
            <Link to="/contact-support">Contact Support</Link>
          </div>

          <div className={styles.contact}>
            <h4>Support</h4>
            <a href="mailto:support@pccheckr.com" className={styles.emailLink}>
              <Mail size={18} /> support@pccheckr.com
            </a>
            <p className={styles.response}>Average response time: &lt; 24h</p>
            <div className={styles.statusBadge}>
              <span className={styles.statusDot}></span> <span>Systems Operational</span>
            </div>
          </div>
        </div>

        <div className={styles.bottom}>
          <p>&copy; {new Date().getFullYear()} PCCheckr. All rights reserved.</p>
        </div>

        <div className={styles.legalDisclaimer}>
          <strong>Security Notice:</strong> PCCheckr uses industry-standard encryption for all data transfers. We only collect technical system metadata required for diagnostic analysis. We do not access personal documents, browsing history, photos, or sensitive credentials. Reports are informational guidance only.
        </div>
      </div>
    </footer>
  );
};
